




























































































import { mapState } from 'vuex';

import changeLogMixin from '@adobe/edex/frontend/views/course/settings/mixin';
import * as courseAPI from '@adobe/edex/frontend/api/course';

const getInitialState = initialCourse => ({
  publishAt: initialCourse.publishAt,
  startsAt: initialCourse.startsAt,
  graduationAt: initialCourse.graduationAt,
  enrollmentOpensAt: initialCourse.enrollmentOpensAt,
  closesAt: initialCourse.closesAt,
  enrollmentClosesAt: initialCourse.enrollmentClosesAt,
  forumClosesAt: initialCourse.forumClosesAt,
});

export default {
  mixins: [changeLogMixin],
  props: {
    initialCourse: {
      type: Object,
      required: true,
    },
  },
  data() {
    return getInitialState(this.initialCourse);
  },
  components: {
    Datepicker: () =>
      import(/* webpackChunkName: "datepicker" */ 'vuejs-datepicker'),
  },
  methods: {
    resetChanges() {
      Object.assign(this.$data, getInitialState(this.initialCourse));
    },
  },
  watch: {
    ...[
      'publishAt',
      'startsAt',
      'graduationAt',
      'enrollmentOpensAt',
      'closesAt',
      'enrollmentClosesAt',
      'forumClosesAt',
    ].reduce((acc, name) => {
      acc[name] = function (current, previous) {
        const data = current
          ? this.$moment.utc(current).format('YYYY-MM-DD')
          : current;

        if (previous !== current) {
          this.onChange({
            name,
            data,
            hasDiff: this.initialCourse[name] != current,
          });
        }
      };
      return acc;
    }, {}),
  },
};
